import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import SidebarModal from 'components/consumer/SidebarModal';
import SuccessMessage from 'components/consumer/SuccessMessage/SuccessMessage';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const SwatchRequestForm = loadable(() => import('components/consumer/swatch-request-form'));
const PDPOrderSwatchesSidebar = t0 => {
  const $ = _c(9);
  const {
    formLocation: t1,
    onClose,
    orderSwatchesAsFirstLevel,
    show
  } = t0;
  const formLocation = t1 === undefined ? "pdp" : t1;
  const [isOrderSwatchesSuccess, setIsOrderSwatchesSuccess] = useState(false);
  if (!show) {
    return null;
  }
  let t2;
  if ($[0] !== formLocation || $[1] !== isOrderSwatchesSuccess || $[2] !== onClose || $[3] !== orderSwatchesAsFirstLevel) {
    t2 = isOrderSwatchesSuccess ? <SuccessMessage onClick={onClose} orderSwatchesAsFirstLevel={orderSwatchesAsFirstLevel} text="Get excited - your swatches will be on their way soon!" bodyText="Your free kit is currently being packed up, and should be shipped out within 14 days. You'll receive a tracking number once it ships." linkText={"\u2190 Keep Shopping"} /> : <div className="text-sm"><SwatchRequestForm hideMessageOnSuccess={true} onSubmitSuccess={() => {
        setIsOrderSwatchesSuccess(true);
      }} formLocation={formLocation} inSidebar={true} /><div className="mt-6 mx-0 mb-0 text-center"><button type="button" className="text-sm font-bold text-gray border-0 [background:none]" onClick={() => onClose(orderSwatchesAsFirstLevel)}>Cancel</button></div></div>;
    $[0] = formLocation;
    $[1] = isOrderSwatchesSuccess;
    $[2] = onClose;
    $[3] = orderSwatchesAsFirstLevel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onClose || $[6] !== show || $[7] !== t2) {
    t3 = <SidebarModal isOpen={show} onClose={onClose} mobileContentUnderHeader={true}>{t2}</SidebarModal>;
    $[5] = onClose;
    $[6] = show;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
PDPOrderSwatchesSidebar.propTypes = {
  formLocation: PropTypes.string,
  onClose: PropTypes.func,
  orderSwatchesAsFirstLevel: PropTypes.bool,
  show: PropTypes.bool
};
export default withBrowserOnly(PDPOrderSwatchesSidebar);